import Marquee from "react-fast-marquee";

const WORDS = [
  "Food-Grade HDPE",
  "SACMI Vision Inspection",
  "Leak-Proof",
  "Compression-Molded",
  "100% Inspected",
  "Custom Color Matching",
  "High-Volume Production",
];

export const Ribbon = ({ dark = false }) => (
  <div
    data-testid="marquee-ribbon"
    className={`py-6 border-y ${
      dark ? "bg-[var(--ink)] border-white/10" : "bg-[var(--brand)] border-transparent"
    }`}
  >
    <Marquee speed={45} gradient={false} autoFill>
      {WORDS.map((w, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display text-2xl md:text-4xl font-medium px-8 ${
              dark ? "text-white" : "text-white"
            }`}
          >
            {w}
          </span>
          <span className={`text-2xl md:text-4xl ${dark ? "text-[#5b8cff]" : "text-white/50"}`}>
            ✳
          </span>
        </span>
      ))}
    </Marquee>
  </div>
);
